export default __webpack_public_path__ + "3e0e80670bfd46226651b7662b7560a2.mp3";